import React from 'react';
import Awards from '../../../success-stories/awards';
import * as S from './style';
import ListItem from '../feature-list/list-item';
import Image from '../../../../../../app/js/components/loggedout/common/Image';
import { white } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import { featureList } from './data';
import { CTAButtonWrapper } from '../../../../common/styled-components/styled-components';
import { CTAPrimaryButton } from '../../../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton';
import Routes from '../../../../routes/routes';
import { Link } from 'react-router-dom';
import StarRating from '~images/sem/star-rating.svg';

const AwardsSection = ({trackPromoPageEvents, settings}) => {
  let ctaText = settings && settings.trial_days ? `Try for free` : 'Subscribe Now';
  let isOddbods = window.location.pathname == "/oddbods";
  return (
    <S.ContainerWrapper noBackground={true}>
      <S.HeadingText>SplashLearn is used by 1 in 3 US Schools</S.HeadingText>
      <S.ListWrapper>
        {
          featureList.map((item)=>
          <ListItem
            item={item}
            fColor={white}
            />
          )
        }
      </S.ListWrapper>
      <Awards widthFull={true}/>
      <CTAButtonWrapper>
        <CTAPrimaryButton white={true}>
          { !isOddbods ?
            <Link to={Routes.PURCHASE_ROUTE} onClick={()=>trackPromoPageEvents("Promo Page Interacted", {'clicked_on' : 'CTA10'}, true)}>
              {ctaText}
            </Link> :
            <Link>
              Coming Soon
            </Link>
          }
        </CTAPrimaryButton>
      </CTAButtonWrapper>
      <S.SubHeadingText moveDown={true}>Over 1000 reviews on App store</S.SubHeadingText>
      <S.RatingImageWrapper>
        <Image src={StarRating}/>
      </S.RatingImageWrapper>
      <S.Rating>We have a 4.6/5 star rating across our products</S.Rating>
    </S.ContainerWrapper>
  )
}

export default AwardsSection;